export const APP_ALOWARE_CLASSIC = 1
export const APP_ALOWARE_TALK = 2
